export enum ContributorTypeEnum {
  CASINO = 'casino',
  SPORT = 'sport',
}
